import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import FooterModal from "../common/FooterModal";
import Button from "../common/Button";

const SortModal = ({ show, value = 0, radioLabels = [], onOk, onClose, seniorLayout = false }) => {
  const { t } = useTranslation();
  const [currentValue, setCurrentValue] = useState(value);

  useEffect(() => {
    setCurrentValue(value);
  }, [value]);

  const items = radioLabels.map((label, index) => ({
    label: t(label),
    value: index,
  }));

  const handleOkClick = () => {
    if (onOk) onOk(currentValue);
  };

  return (
    <FooterModal show={show} onClose={onClose}>
      <div className="w-full flex flex-col items-center gap-y-7 px-10 xs:px-6 pt-7 pb-10">
        <div className="w-full border-b border-b-secondary-border text-3xl font-semibold pb-2 text-left">
          {t("sorting")}
        </div>

        <div className="w-full flex flex-col gap-y-4">
          {items.map((item) => (
            <label key={item.value} className={`w-full flex justify-between items-center font-medium ${seniorLayout ? "text-xl" : "text-lg"}`}>
              <span>{item.label}</span>
              <input
                type="radio"
                name="sortOptions"
                className="ml-auto w-5 h-5"
                checked={currentValue === item.value}
                onChange={() => setCurrentValue(item.value)}
              />
            </label>
          ))}
        </div>

        <Button
          className={`w-32 h-11 font-medium mx-auto justify-self-center ${seniorLayout ? "text-xl" : "text-lg"}`}
          type="primary"
          shape="round"
          onClick={handleOkClick}
        >
          {t("okay")}
        </Button>
      </div>
    </FooterModal>
  );
};

export default SortModal;
